
import { defineComponent, PropType } from 'vue'

export interface V2PaymentMethod {
  id: string
  brand: string
  brandLabel: string
  lastFour: string
  expiryLabel: string
  isDefault: boolean
}

export default defineComponent({
  name: 'V2PaymentMethods',
  props: {
    methods: {
      type: Array as PropType<V2PaymentMethod[]>,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
})
